/* eslint-disable no-use-before-define */
import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Reseller } from 'modules/Reseller/Reseller'
import { Tank } from 'modules/Tank/Tank'
import { Tenant } from 'modules/Tenant/Tenant'
import { Model } from 'pinia-orm'
import { OrgGroup } from 'modules/OrgGroup/OrgGroup'

export class Org extends Model {
  static override entity = 'orgs'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare org_number: string | null
  @Attr(null) declare org_id: number | null
  @Attr(null) declare site: string | null
  @Attr(null) declare address: string | null
  @Attr(null) declare main_contact: string | null
  @Attr(null) declare contact_phone: string | null
  @Attr(null) declare contact_email: string | null
  @Attr(true) declare is_financial: boolean
  @Attr(true) declare is_active: boolean
  @Attr(null) declare status: string | null
  @Attr(null) declare subscription_type: string | null
  @Attr(false) declare owns_equipment: boolean
  @Attr(null) declare reseller_id: string | null
  @Attr(false) declare require_subs: boolean
  @Attr(false) declare enable_projects: boolean
  @Attr(false) declare allow_sentry: boolean
  @Attr(true) declare can_qr_scan: boolean
  @Attr(false) declare can_add_equipment: boolean
  @Attr(false) declare hide_manual_equipment_select: boolean
  @Attr(false) declare manual_transactions: boolean
  @Attr(false) declare app_hide_inactive_equipment_default: boolean
  @Attr(null) declare paramaters: string | null
  @Attr(null) declare custom_dispense_auth: number | null
  @Attr(true) declare allow_hardware: boolean
  @Attr(false) declare allow_shake: boolean
  @Attr(false) declare user_save_password: boolean
  @Attr(false) declare allow_offline_login: boolean
  @Attr(false) declare is_trial: boolean
  @Attr(null) declare trial_expires_on: string | null
  @Attr(false) declare allow_search: boolean
  @Attr(null) declare max_transactions_shown: number | null
  @Attr(false) declare allow_levels: boolean
  @Attr(null) declare transaction_sync_default_hours: number | null
  @Attr(false) declare allow_batch_odo: boolean
  @Attr(null) declare connection_drop: string | null
  @Attr(null) declare query_size: number | null
  @Attr(false) declare options: string
  @Attr(false) declare settings: string
  @Attr(false) declare allow_custom_qr: boolean
  @Attr(null) declare number_of_seats: number | null
  @Attr(null) declare max_transactions_per_day: number | null
  @Attr(null) declare days_since_last_transaction: number | null
  @Attr(false) declare can_scan_tanks: boolean
  @Attr(false) declare enable_transaction_notes: boolean
  @Attr(null) declare transaction_notes_name: string | null
  @Attr(null) declare transaction_notes_placeholder: string | null
  @Attr(false) declare report_damage: boolean
  @Attr(false) declare enable_transaction_notes_2: boolean
  @Attr(null) declare notes_2_field_name: string | null
  @Attr(null) declare timezone: string | null
  @Attr(null) declare notes_2_field_placeholder: string | null
  @Attr(null) declare auto_sync_interval_minutes: number | null
  @Attr(false) declare require_project_select: boolean
  @Attr(null) declare reseller_org_id: string | null
  @Attr(null) declare is_reseller: boolean
  @Attr(null) declare tenant_id: string

  @BelongsTo(() => Reseller, 'reseller_id') declare reseller: Reseller | null
  @BelongsTo(() => OrgGroup, 'org_group_id') declare orgGroup: OrgGroup | null
  @BelongsTo(() => Org, 'reseller_org_id') declare reseller_org: Org | null
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null

  @HasMany(() => Tank, 'tank_id') declare tanks: Tank[]
}
